// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fC-z","smallCardRow":"gC-z","largeCardRow":"hC-z","productSearchRow":"iC-z","curatedRow":"jC-z"};